import { getEllipsisTxt } from "../../helpers/formatters";
import { useEffect, useState } from "react";
import Address from "../Address/Address";
import { connectors } from "./config";
import {
    useEagerConnect,
    useInactiveListener,
    useNetworkScanURL,
} from "../../hooks";
import { useWeb3React } from "@web3-react/core";
import { FaExternalLinkAlt } from "react-icons/fa";
import { injected, walletconnect } from "../../connector";

import { useStore } from "../../utils/store";
import Blockie from "../UI/Blockie";
import Web3 from "web3";

const wallets = {
    injected: injected,
    walletconnect: walletconnect,
};

const Account = ({
    additionalHandler,
    modalstyle = true,
    className,
    buttonclassname,
}) => {
    const profile = useStore((state) => state.profile);
    const setProfile = useStore((state) => state.setProfile);
    const fetchProfile = useStore((state) => state.fetchProfile);

    const NETWORK_SCAN_URL = useNetworkScanURL();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);

    const { active, account, activate, deactivate, library } = useWeb3React();

    const triedEager = useEagerConnect();
    useInactiveListener(!triedEager);

    useEffect(() => {
        if (account) fetchProfile(account);
        else setProfile(undefined);

        if (library) {
            const web3 = new Web3(library.provider);
            window.web3 = web3;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account, library]);

    async function disconnectAccount() {
        try {
            deactivate();
        } catch (ex) {
            console.log(ex);
        }
    }

    const connectAccount = async (connectorId) => {
        try {
            await activate(wallets[connectorId]);
        } catch (error) {
            alert(error);
        }
    };

    const onClickHandler = () => {
        if (active) setIsModalVisible(true);
        else setIsAuthModalVisible(true);
    };

    const providerSelector = () => {
        return (
            <div
                className={
                    modalstyle
                        ? "grid grid-cols-2"
                        : "flex flex-col overflow-hidden mx-auto w-full md:w-96 border-2 border-kadComponentBorder rounded-lg"
                }
            >
                {connectors.map(({ title, icon, connectorId, badge }, key) => (
                    <div
                        className={`${
                            modalstyle
                                ? "flex-col py-5 rounded-lg"
                                : "flex-row py-2 gap-x-4 px-4 border-b-2 border-kadComponentBorder last:border-0"
                        } flex group items-center cursor-pointer hover:bg-white/5 hover:shadow-lg duration-150`}
                        key={key}
                        onClick={async () => {
                            try {
                                await connectAccount(connectorId);
                                additionalHandler && additionalHandler();
                                setIsAuthModalVisible(false);
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                    >
                        <img src={icon} alt={title} className="h-8 w-8 my-2" />
                        <span className="size-base">{title}</span>
                        {badge && (
                            <span
                                className={`${
                                    modalstyle ? "hidden" : "ml-auto"
                                } size-sm rounded-full px-2 py-1 bg-kadido-gr`}
                            >
                                {badge}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    if (modalstyle === false) {
        return providerSelector();
    }
    return (
        <div className={className || "flex"}>
            <button
                className={
                    buttonclassname ||
                    "blueGradient-button py-3 size-base font-semibold"
                }
                onClick={onClickHandler}
            >
                {profile &&
                    (profile?.avatarLink ? (
                        <img
                            className="w-10 h-10 mr-4 rounded-full border border-kadComponentBorder"
                            src={profile.avatarLink}
                            alt="profile avatar"
                        />
                    ) : (
                        <Blockie
                            address={profile.wallet}
                            className="rounded-full mr-4 border border-kadComponentBorder"
                            scale={4}
                        />
                    ))}
                <div className="flex flex-col">
                    {profile && (
                        <span className="text-right leading-none ml-auto px-2 w-fit border-b border-kadComponentFocus">
                            {profile?.username === profile?.wallet
                                ? "unnamed"
                                : profile?.username}
                        </span>
                    )}
                    <span>
                        {active ? getEllipsisTxt(account, 4) : "Connect Wallet"}
                    </span>
                </div>
            </button>

            <div className={`${isModalVisible ? "flex" : "hidden"} ace-modal`}>
                <div
                    className="ace-modal-overlay"
                    onClick={() => setIsModalVisible(false)}
                />
                <div className="ace-modal-main w-60 2xl:w-80">
                    <div className="ace-modal-header">
                        <span>Account</span>
                        <button
                            type="button"
                            className="ace-modal-close-button"
                            onClick={() => setIsModalVisible(false)}
                        >
                            <svg
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div className="ace-modal-body rounded-b-lg p-4 flex flex-col items-center">
                        <div className="flex items-center gap-2 mb-4">
                            <Address
                                account={account}
                                avatar="left"
                                size={6}
                                copyable
                            />
                            <a
                                href={`${NETWORK_SCAN_URL}${account}`}
                                target="_blank"
                                rel="noreferrer"
                                className="text-cyan-400 hover:text-cyan-600 items-center"
                            >
                                <FaExternalLinkAlt />
                            </a>
                        </div>

                        <button
                            className="secGr-button w-fit"
                            onClick={async () => {
                                disconnectAccount();
                                setIsModalVisible(false);
                            }}
                        >
                            Disconnect Wallet
                        </button>
                    </div>
                </div>
            </div>

            <div
                className={`${
                    isAuthModalVisible ? "flex" : "hidden"
                } ace-modal`}
            >
                <div
                    className="ace-modal-overlay"
                    onClick={() => setIsAuthModalVisible(false)}
                />
                <div className="ace-modal-main w-96">
                    <div className="ace-modal-header">
                        <span>Connect Wallet</span>
                        <button
                            type="button"
                            className="ace-modal-close-button"
                            onClick={() => setIsAuthModalVisible(false)}
                        >
                            <svg
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div className="ace-modal-body rounded-b-lg">
                        {providerSelector()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Account;
